import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import React, { PropsWithChildren, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import { ApplicationInsightsContext } from './ApplicationInsightsContext';

function configureApplicationInsights(navigate: any): { reactPlugin: ReactPlugin; appInsights: ApplicationInsights } | null {
  const { applicationInsightsKey } = config;
  if (!applicationInsightsKey) {
    return null;
  }

  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: applicationInsightsKey,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { navigate },
      },
      enableCorsCorrelation: true,
      correlationHeaderExcludePatterns: [/adressevaelger\.dk/],
      autoTrackPageVisitTime: true,
      enableUnhandledPromiseRejectionTracking: true,
      enableDebug: config.deployEnvironment === 'develop',
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((item) => {
    if (!item) return;

    item.tags!['ai.cloud.role'] = 'FSL.MemberPortal.Frontend';
  });

  appInsights.addTelemetryInitializer((item) => {
    if (item.data?.message === 'Error: No matching state found in storage') {
      return false;
    }

    return true;
  });

  appInsights.context.application.ver = `${process.env.REACT_APP_VERSION}`;

  return { reactPlugin, appInsights };
}

export function ApplicationInsightsProvider({ children }: PropsWithChildren<{}>) {
  const navigate = useNavigate();
  const [ai, setAi] = useState<{ reactPlugin: ReactPlugin; appInsights: ApplicationInsights } | null>();

  if (ai === undefined) {
    setAi(configureApplicationInsights(navigate));
    return <></>;
  }

  return <ApplicationInsightsContext.Provider value={ai}>{children}</ApplicationInsightsContext.Provider>;
}
